'use strict';

const Enum = require('./enum');

/**
 * Defines actions around external credential
 * sync commands.
 *
 * @enum
 * @readonly
 */
const LockExternalCredentialActions = Object.create(Enum, {
  LOAD: { value: 'load', enumerable: true },
  DELETE: { value: 'delete', enumerable: true },
});

/**
 * Defines states around external credential commands.
 *
 * @enum
 * @readonly
 */
const LockExternalCredentialCommandStates = Object.create(Enum, {
  INTENT: { value: 'intent', enumerable: true },
  COMMIT: { value: 'commit', enumerable: true },
});

/**
 * Defines states of external credentials.
 *
 * @enum
 * @readonly
 */
const LockExternalCredentialStates = Object.create(Enum, {
  CREATED: { value: 'created', enumerable: true },
  LOADED: { value: 'loaded', enumerable: true },
  DELETING: { value: 'deleting', enumerable: true },
});

exports.LockExternalCredentialActions = LockExternalCredentialActions;
exports.LockExternalCredentialCommandStates = LockExternalCredentialCommandStates;
exports.LockExternalCredentialStates = LockExternalCredentialStates;
